<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>领券中心</span></div>
			
			<div class="user-login-content" v-if="list.length > 0">
				<div class="list flex-start flex-wrap">
					<div class="coupon" v-for="(item, index) in list" :key="item.id">
						<div class="item-top flex-between flex-center">
							<div class="item-top-left">
								<div>{{item.minusAmount}}元</div>
								<div>满减券</div>
							</div>
							<div class="item-top-center">
								<div>{{item.name}}</div>
								<div v-if="item.receiveStatus != 0">待领取</div>
								<div v-else>已领取</div>
							</div>
							 <!-- v-if="item.receiveStatus != 0" -->
							<div class="item-top-right" v-if="item.receiveStatus != 0" @click="getCoupon(item, index)">立即领取</div>
						</div>
						
						<div class="item-bottom">
							有效期: {{item.endTime}}
						</div>
						<div class="item-hr flex-between flex-center">
							<div class="item-left"></div>
							<div class="item-right"></div>
						</div>
					</div>
				</div>
			</div>
			
			<noData v-if="list.length == 0 && isLoad == true" msg="暂无可领取的优惠券"></noData>
			
		</div>
	  </div>
	</div>
</template>

<script>
import noData from '@/components/noData.vue'
import {couponList,couponReceive} from "@/api/index"
export default {
	name: 'index',
	components:{
		noData
	},
	data(){
		return {
			list:[],
			isLoad:false
		}
	},
	mounted() {
		this.isLoad = false;
		this.getList();
	},
	methods:{
		getList(){
			couponList().then(res=>{
				if(res.code == 1000){
					this.list = res.data;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getCoupon(info, index){
			couponReceive({couponId:info.id}).then(res=>{
				if(res.code == 1000){
					this.$message.success("领取成功");
					this.list[index].receiveStatus = 0;
				}else{
					return this.$message.error(res.message);
				}
				
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	.list{
		width: 1320px;
		background: #FFFFFF;
		padding: 40px;
		box-sizing: border-box;
	}
	.coupon{
		width: 386px;
		background: rgba(248,248,248, 1);
		position: relative;
		margin-right: 40px;
		height: 122px;
		margin-bottom: 20px;
		.item-hr{
			position: absolute;
			left: 0px;
			bottom: 22px;
			width: 386px;
			height: 20px;
			.item-left{
				width: 10px;
				height: 20px;
				background: #fff;
				border-radius: 0px 10px 10px 0px;
			}
			.item-right{
				width: 10px;
				height: 20px;
				background: #fff;
				border-radius: 10px 0px 0px 10px;
			}
		}
		.item-bottom{
			width: 100%;
			height: 32px;
			background: rgba(7, 11, 19, 0.1);
			font-size: 14px;
			line-height: 32px;
			text-align: center;
			color: rgba(7, 11, 19, 0.3);
		}
		.item-top{
			padding: 22px 16px 16px 0px;
			.item-top-left{
				color: rgba(233, 26, 18, 1);
				font-weight: 500; 
				width: 104px;
				flex: 0 0 104px;
				text-align: center;
				div{
					&:first-of-type{
						font-size: 24px;
						line-height: 26px;
					}
					&:last-of-type{
						font-size:12px;
						line-height: 26px;
					}
				}
			}
			.item-top-center{
				width: 100%;
				div{
					&:first-of-type{
						font-size: 16px;
						font-weight: 500;
						line-height: 20px;
						color: #070B13;
	
					}
					&:last-of-type{
						width: 48px;
						height: 20px;
						border-radius: 2px;
						background: rgba(255, 29, 20, 0.1);
						margin-top: 8px;
						font-size: 14px;
						line-height: 20px;
						text-align: center;
						color: #E91A12;
					}
				}
			}
			.item-top-right{
				width: 88px;
				height: 28px;
				border-radius: 4px;
				background: #E91A12;
				font-size: 16px;
				font-weight: 500;
				line-height: 28px;
				text-align: center;
				color: #FFFFFF;
				flex: 0 0 88px;
				cursor: pointer;
			}
		}
	}
	.coupon:nth-of-type(3n+3){
		margin-right: 0px;
	}
</style>
